import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { convertToDate } from '../../../../../../utils/helpers.utils';
import { OrderRequestFiles } from "../../request-details-files.component";
import Translation from "../../../../../common/translation/translation.component";
import { RequestOnBehalfDetails } from '../.././request-on-behalf-details.component';
import Icons from '../../../../../icon';
import { ORDER_STATUS, CIRCUIT_STATUS } from '../../../../../../constants/external-constants';
import { withRouter } from 'react-router-dom';
import FormatDate from "../../../../../common/date/format-date.component";

class IntlRoamingAccessDetails extends Component {
    constructor(props) {
        super(props);
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    editRequest = (orderStatusId, endUserId, requestorId, path) => {
        const editableRequest = (orderStatusId === ORDER_STATUS.waitingForAuthorization || orderStatusId === ORDER_STATUS.open );
        var employeeId = sessionStorage.getItem('EmployeeID');
        const isRequestOwner = (endUserId == employeeId) || (requestorId == employeeId);
        return editableRequest && isRequestOwner && !path;
    }
    render() {
        const { status, openRequestModal, data, isWireline, selectedItem, path } = this.props;
        const { Order: { RequestType: { RequestTypeID, RequestType }, OrderStatusId, EndUserId, RequestorId } } = data || {};
        return (
            <div>                
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                    {this.editRequest(OrderStatusId, EndUserId, RequestorId, path) ?   
                         <Icons
                         customClassName="pen-to-square" 
                         name="pen-to-square"
                         size="20px"
                         containerClass="icon-circle-plus-container"
                         onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                         labelValue={"Update Order Request"}
                         labelClass="order-detail-edit-label"                                                              
                     />

                        : null 
                    }
                </h4>
                <div className="order-detail-location">
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="order_number" />
                        </div>
                        <div className="order-label">
                            {data.Order.OrderNumber}
                        </div>
                    </div>
                    {data.Order.IsRequestedInBehalf ?
                        <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                        : null}
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td className="mobile-number-label"><Translation translationKey="mobile_phone_number" /></td>
                                <td className="mobile-number-label">{data.Circuit.CircuitCode}</td>
                            </tr>

                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className={data.Subscription.CircuitStatus == CIRCUIT_STATUS.inService.name ? "status-inservice" : data.Subscription.CircuitStatus == CIRCUIT_STATUS.suspended.name ? "status-suspended" : ""} >{data.Subscription.CircuitStatus}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.VendorName}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription.PlanDetails.PlanName != null ? data.Subscription.PlanDetails.PlanName : <Translation translationKey="no_plan_available" /> }</td>
                            </tr>
                          
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription && data.Subscription.SubscriptionDetailDevice ?
                                    data.Subscription.SubscriptionDetailDevice.EquipmentModel :
                                    <Translation translationKey="no_device_available" />} </td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="intl_roaming_access_details" /></h5>
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="request_only" /></td>
                                <td>{data.Order.RequestType.RequestType}</td>
                            </tr>
                             <tr>
                                <td><Translation translationKey="intl_roam_acc_start_date" /></td>
                                <td>
                                    <FormatDate date={data.Order.StartDate} />
                                </td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="intl_roam_acc_end_date" /></td>
                                <td>
                                    <FormatDate date={data.Order.EndDate} />
                                </td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="business_justification" /></td>
                                <td>{data.BusinessJustification.BusinessJustification}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="country" /></td>
                                <td>{data.Order.CountriesToBeVisited}</td>
                            </tr>                          
                            <tr>
                                <td><Translation translationKey="additional_information" /></td>
                                <td>{data.BusinessJustification.AdditionalInformation}</td>
                            </tr>
                        </tbody>
                    </Table>
                    {isWireline &&
                        <OrderRequestFiles files={data.Order.OrderFileNames} />
                    }
                </div>
            </div>
        );
    }
}

export default withRouter(IntlRoamingAccessDetails)